import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {Grid, Radio, RadioGroup} from "@mui/material";

// Context
import {ClickAndCollectListContext} from "../../../context/ClickAndCollectListContext";

// Components
import FormControlLabel from "components/radioGroup/FormControlLabel";
import CustomButton from "components/CustomButton";
import BottomDrawer from "components/WMS/Mobile/BottomDrawer";

import {getTranslation} from "domain/helpers/translations";

CancellationReasonDrawer.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func,
    cancellationReasons: PropTypes.arrayOf(PropTypes.object).isRequired,
    setSelectedReason: PropTypes.func.isRequired
};

function CancellationReasonDrawer({isOpen, handleClose = () => {}, cancellationReasons, setSelectedReason}) {
    const [choiceValue, setChoiceValue] = React.useState(null);

    return (
        <BottomDrawer
            open={isOpen}
            onClose={handleClose}
            openMaxHeight
            noHeightLimit
            title={<FormattedMessage id='wms.cc.list.takeoutShipment.popup.cancellationReason.drawer.title' />}
            subtitle={<FormattedMessage id='wms.cc.list.takeoutShipment.popup.cancellationReason.drawer.subtitle' />}
        >
            <Grid
                container
                direction={"column"}
                justifyContent={"space-between"}
                sx={{
                    height: '100%',
                    flexWrap: 'nowrap'
                }}
            >
                <Grid item>
                    <RadioGroup
                        onChange={(event) => setChoiceValue(event.target.value)}
                        value={choiceValue}
                    >
                        {cancellationReasons && cancellationReasons.map((cancellationReason) => (
                            <FormControlLabel
                                control={<Radio />}
                                key={cancellationReason.id}
                                value={cancellationReason.id}
                                label={getTranslation(cancellationReason).name}
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    margin: 0,
                                    padding: "16px",
                                    border: 'unset',
                                }}
                            />
                        ))}
                    </RadioGroup>
                </Grid>
                <Grid item sx={{padding: '8px'}}>
                    <CustomButton
                        fullWidth
                        disabled={!choiceValue}
                        onClick={() => {
                            setSelectedReason(cancellationReasons.find(reason => reason.id === choiceValue));
                            handleClose();
                        }}
                    >
                        <FormattedMessage id='wms.cc.list.takeoutShipment.popup.cancellationReason.validate' />
                    </CustomButton>
                </Grid>
            </Grid>
        </BottomDrawer>
    );
}

export default CancellationReasonDrawer;
